import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Services from "./components/Services";
import ContactForm from "./components/ContactForm";
import VacuumExcavation from "./components/VacuumExcavation";
import Projects from "./components/Instagram";
import Reviews from "./components/Reviews";
import OneTeam from "./components/OneTeam";
import FAQ from "./components/FAQ";
import CtaFooter from "./components/CtaFooter";
import FloatingCall from "./components/FloatingCall";
import ReviewsPage from "./components/ReviewsPage";
import ContactPage from "./components/ContactPage";
import ReportsPage from "./components/ReportsPage";

const Home = () => (
  <main>
    <Hero />
    <Services />
    <ContactForm />
    <VacuumExcavation />
    <Projects />
    <Reviews />
    <OneTeam />
    <FAQ />
  </main>
);

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/reviews" element={<ReviewsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/reports" element={<ReportsPage />} />
        </Routes>
        <CtaFooter />
        <FloatingCall />
      </BrowserRouter>
    </div>
  );
}

export default App;
